<script setup lang="ts">
import type { components as StrapiComponents } from '@core/types/clients/strapi'
import { computed } from '#imports'

const props = defineProps<{
    usps?: StrapiComponents['schemas']['SharedUspComponent'][]
}>()

const uspWidth = computed(() => {
    if (!props.usps || props.usps.length === 0) return '100%'
    return `${100 / props.usps.length}%`
})
</script>

<template>
    <section class="usp-bar container container--lg">
        <div v-for="(usp, index) in props.usps" :key="index" class="usp-container">
            <div class="usp">
                <!-- eslint-disable-next-line vue/no-v-html usp is safe -->
                <figure v-html="usp.icon" />
                <div>
                    <h2>{{ usp.title }}</h2>
                    <p>{{ usp.subtitle }}</p>
                </div>
            </div>
            <span v-if="props.usps && index < props.usps.length -1" class="usp-divider" />
        </div>
    </section>
</template>

<style scoped lang="scss">
.usp-bar {
    display: flex;
    width: 100%;
    padding: 20px 0;

    .usp-container {
        display: flex;
        width: v-bind(uspWidth);
    }
}

.usp {
    display: flex;
    width: 100%;
    justify-content: center;

    figure {
        margin: 0;
        padding: 0 3px 0 0;
        font-size: $font-size-sm;

        @include tablet {
            font-size: $font-size-lg;
        }
    }

    div {
        display: flex;
        flex-direction: column;

        h2 {
            font-family: $brand-font-family;
            font-weight: $text-extra-bold;
            margin: 0;
            font-size: 3.9vw;
            font-size: clamp(12px, 3.9vw, 16px);
            font-style: normal;
            color: $brand-success;

            @include tablet {
                font-size: $font-size-xl;
            }
        }

        p {
            font-weight: $text-extra-bold;
            font-size: 2.8vw;
            font-size: clamp(9px, 2.8vw, 12px);
            margin: 0;

            @include tablet {
                font-size: $font-size-sm;
            }
        }
    }
}

.usp-divider {
    border-style: solid;
    border-color: rgb(255 255 255 / 10%);
    border-width: 0 1px 0 0;
    height: 42px;
}
</style>
